import { render, staticRenderFns } from "./DataSetMetadataSchemaDetail.vue?vue&type=template&id=5dc09c47&scoped=true"
import script from "./DataSetMetadataSchemaDetail.vue?vue&type=script&lang=js"
export * from "./DataSetMetadataSchemaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc09c47",
  null
  
)

export default component.exports